import api from "./api";
import { Order, OrderStatus, Payment, Role, UserProfile } from "../model/types";

export const getAllOrders = async (): Promise<Order[]> => {
  const response = await api.get<Order[]>("/orders");
  return response.data;
};

export const updateOrderStatus = async (
  orderId: number,
  status: OrderStatus
): Promise<Order> => {
  const response = await api.patch<Order>(`/orders/${orderId}/status`, {
    status,
  });
  return response.data;
};

export const getAllPayments = async (): Promise<Payment[]> => {
  const response = await api.get<Payment[]>("/payments");
  return response.data;
};

export const getAllUsers = async (): Promise<UserProfile[]> => {
  const response = await api.get<UserProfile[]>("/users");
  return response.data;
};

export const createUser = async (payload: {
  fullName: string;
  email: string;
  password: string;
  role: Role;
}): Promise<UserProfile> => {
  const response = await api.post<UserProfile>("/users", payload);
  return response.data;
};

// export const deleteUser = async (userId: number): Promise<void> => {
//   await api.delete(`/users/${userId}`);
// };

export const getProfile = async (): Promise<UserProfile> => {
  const response = await api.get<UserProfile>("/users/me");
  return response.data;
};
